import React, { PureComponent } from 'react';

import { Loader } from 'react-loaders';

import { getRequest } from '../../../../api/ApiService';
import {
  Wrapper,
  Title,
  Text,
  DataContainer,
  DataContainerTitle,
  FourColumnsRow,
  DataColumn,
  DataTitle,
  ButtonRow,
  Button
} from '../components/ui';
import InputPercentage from '../components/input-percentage';

import ErrorAlert from '../../../../components/alerts/error';
import SuccessAlert from '../../../../components/alerts/success';

import { putRequest } from "../../../../api/ApiService";

class OverallScore extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamScore: 0,
      peerScore: 0,
      feedbackSubmission: 0,
      engagementScore: 0,
      gradingWeightsID: 0,
      courseID: 0,
      valueChanged: false,
      showError: false,
      showSuccess: false
    };
  }

  componentDidMount() {
    getRequest(`${process.env.REACT_APP_API_URL}v2/games/gradingweights`)
      .then(res => {
        const gradingWeights = res.body.results[0] ? res.body.results[0] : null;

        if (gradingWeights) {
          const teamScore = gradingWeights.team_grade ? Number(gradingWeights.team_grade * 100).toFixed(2) : '0.00';
          const peerScore = gradingWeights.peer_weight ? Number(gradingWeights.peer_weight * 100).toFixed(2) : '0.00';
          const feedbackSubmission = gradingWeights.feedback_submission ? Number(gradingWeights.feedback_submission * 100).toFixed(2) : '0.00';
          const engagementScore = gradingWeights.engagement_score ? Number(gradingWeights.engagement_score * 100).toFixed(2) : '0.00';

          this.setState({
            loaded: true,
            teamScore,
            peerScore,
            feedbackSubmission,
            engagementScore,
            gradingWeightsID: gradingWeights.id,
            courseID: gradingWeights.course
          });
        }
      })
      .catch(err => { });
  }

  handleInputChange = (name, value) => {
    this.setState({
      [name]: value,
      valueChanged: true
    });
  }

  submitOverallScore = () => {
    const {
      teamScore,
      peerScore,
      feedbackSubmission,
      engagementScore,
      gradingWeightsID,
      courseID
    } = this.state;

    const sum = Number(teamScore) + Number(peerScore) + Number(feedbackSubmission) + Number(engagementScore);
    if (sum !== 100) {
      this.setState({
        showError: true
      });
      return;
    }

    putRequest(
      `${process.env.REACT_APP_API_URL}v2/games/gradingweights/${gradingWeightsID}/`
    ).send({
      team_grade: teamScore / 100,
      peer_weight: peerScore / 100,
      feedback_submission: feedbackSubmission / 100,
      engagement_score: engagementScore / 100,
      course: courseID
    })
      .then(() => {
        this.setState({
          valueChanged: false,
          showSuccess: true
        });
      })
      .catch(() => { });
  }

  hideError = () => {
    this.setState({
      showError: false
    });
  };

  render() {
    const {
      loaded,
      teamScore,
      peerScore,
      feedbackSubmission,
      engagementScore,
      valueChanged,
      showError,
      showSuccess
    } = this.state;

    const buttonText = valueChanged ? 'Update' : 'Updated';

    return loaded ? (
      <Wrapper>
        {showError && (
          <ErrorAlert
            title='Error | Must equal 100% '
            message='The sum of the grading weight does not equal 100%. Please modify to ensure that its 100%.'
            onHide={this.hideError}
          />
        )}
        <Title>OVERALL SCORE | INDIVIDUAL SCORE</Title>
        <Text>A student’s overall score is the weighted average of their team’s performance (i.e. <b>team score</b>), how well they worked in teams (i.e. <b>peer score</b>), if they provided peer feedback to their teammates (<b>feedback submission score</b>), and if they reviewed the reading materials (i.e. <b>engagement score</b>).</Text>
        {showSuccess && (
          <SuccessAlert
            title="Success!"
            message="The Grading weights are updated."
            onHide={this.hideError}
          />
        )}
        <DataContainer>
          <DataContainerTitle>Set Grading Weight</DataContainerTitle>
          <FourColumnsRow>
            <DataColumn>
              <DataTitle>Team Score</DataTitle>
              <InputPercentage
                value={teamScore}
                name="teamScore"
                onInputChange={this.handleInputChange}
              />
            </DataColumn>
            <DataColumn>
              <DataTitle>Peer Score</DataTitle>
              <InputPercentage
                value={peerScore}
                name="peerScore"
                onInputChange={this.handleInputChange}
              />
            </DataColumn>
            <DataColumn>
              <DataTitle>Feedback Submission</DataTitle>
              <InputPercentage
                value={feedbackSubmission}
                name="feedbackSubmission"
                onInputChange={this.handleInputChange}
              />
            </DataColumn>
            <DataColumn>
              <DataTitle>Engagement score</DataTitle>
              <InputPercentage
                value={engagementScore}
                name="engagementScore"
                onInputChange={this.handleInputChange}
              />
            </DataColumn>
          </FourColumnsRow>
          <ButtonRow>
            <Button
              type="button"
              onClick={this.submitOverallScore}
              disabled={!valueChanged}
            >
              {buttonText}
            </Button>
          </ButtonRow>
        </DataContainer>
        <Text><strong>Note:</strong> Individual score is calculated at the end of the simulation experience. </Text>
      </Wrapper>
    ) : <Wrapper><Loader type="ball-scale-ripple" active /></Wrapper>;
  }

}

export default OverallScore;



// WEBPACK FOOTER //
// ./src/instructor/components/grading/pages/overall-score.js